<template>
	<label>
		<common-tooltip class="setting-label" :icon="icon" :forceShow="forceShow">
			<template v-slot:tooltip><slot name="tooltip">{{ tooltip }}</slot></template>
			<span class="setting-label-text"><slot name="label">{{ label }}</slot></span>
		</common-tooltip>

		<slot></slot>
	</label>
</template>
<script>
export default {
	props : {
		label     : String,
		tooltip   : String,
		forceShow : Boolean,
		icon      : {
			type : [ String, Boolean ],
			default () {
				return 'default-help'
			},
		},
	},
}
</script>
